import { NgModule } from '@angular/core';
import { MyModuleComponent } from './my-module-component';


@NgModule({
    declarations: [MyModuleComponent],
    exports: [MyModuleComponent]
})
export class MyModule { }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/dev-playground/my-module/my-module.ts